import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
export default function Hero() {
  return <section data-section-id="230325" id="hero" className="bg-background text-foreground relative min-h-[90vh] flex items-center overflow-hidden py-20 lg:py-32">
      <div className="absolute inset-0 pointer-events-none" style={{
      backgroundImage: "url(https://fulcro.mx/wp-content/uploads/2026/04/fulcro-textura-fulcrums-dark.svg)",
      backgroundRepeat: "repeat",
      backgroundSize: "440px",
      opacity: 0.4,
      maskImage: "radial-gradient(ellipse at center, black 0%, transparent 78%)",
      WebkitMaskImage: "radial-gradient(ellipse at center, black 0%, transparent 78%)"
    }} aria-hidden="true" />
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="max-w-4xl mx-auto">
          <div className="flex flex-col items-center text-center">
            <img src="https://fulcro.mx/wp-content/uploads/2026/04/fulcro-isotipo-dark.svg" alt="Fulcro" className="h-16 md:h-20 w-auto mb-12 md:mb-16" />
            <h1 className="font-serif text-5xl sm:text-6xl lg:text-[72px] leading-[1.1] font-normal text-foreground tracking-tight">
              El punto exacto donde la tecnología multiplica tu negocio.
            </h1>
            <p className="mt-8 text-lg sm:text-xl text-muted-foreground max-w-2xl font-sans font-light leading-relaxed">
              Consultoría e implementación tecnológica con criterio de rentabilidad. Diagnosticamos antes de automatizar. Recomendamos la herramienta correcta — a veces es IA, a veces es un proceso mejor, a veces son doce líneas de código.
            </p>
            <div className="mt-10">
              <a href="https://fulcro.mx/contacto/">
                <Button size="lg" className="h-14 px-8 text-base font-medium bg-primary hover:bg-primary/90 text-primary-foreground rounded-sm transition-colors duration-300">
                  Hablemos 30 minutos
                  <ArrowRight className="ml-2 size-5" aria-hidden="true" />
                </Button>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>;
}